import { render } from "./MensagemAlerta.vue?vue&type=template&id=400130a9&scoped=true"
import script from "./MensagemAlerta.vue?vue&type=script&lang=js"
export * from "./MensagemAlerta.vue?vue&type=script&lang=js"

import "./MensagemAlerta.vue?vue&type=style&index=0&id=400130a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-400130a9"]])

export default __exports__